export function loadAccordionPlugin() {
  FroalaEditor.PLUGINS.accordion = function (editor) {
    function insertAccordion() {
      const section = `<div class="h5p-wysiwyg-accordion collapse-panel">
        <div class="collapse-title" onclick="this.parentElement.classList.toggle('active')">
          <h3>PANEL TITLE</h3>
        </div>
        <div class="panel-content">
          <div class="panel-content-inner">Panel content</div>
        </div>
      </div>
      <br>`;

      editor.html.insert(section);
    }

    return {
      insertAccordion
    };
  };

  FroalaEditor.DefineIcon('accordion', {
    SRC: '/assets/images/froala-plugins/accordion.icon.svg',
    ALT: 'Accordion',
    template: 'image',
  });

  // Register the command
  FroalaEditor.RegisterCommand('accordion', {
    title: 'Insert accordion',
    icon: 'accordion',
    undo: true,
    focus: true,
    callback: function () {
      this.accordion.insertAccordion();
    }
  });

  FroalaEditor.RegisterQuickInsertButton('accordion', {
    title: 'Insert accordion',
    icon: 'accordion',
    undo: true,
    focus: true,
    callback: function () {
      this.accordion.insertAccordion();
    }
  });

  FroalaEditor.LANGUAGE['de'] = FroalaEditor.LANGUAGE['de'] || {};

  // Extend it with your plugin's translations
  Object.assign(FroalaEditor.LANGUAGE['de'].translation, {
    'Insert accordion': 'Accordion einfügen',
  });
}
